// ChartSettingsButton.js
import React, { useState } from 'react';
import { 
  IconButton, 
  Tooltip 
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import ChartSettings from './ChartSettings';

/**
 * Button component for opening chart settings
 * 
 * @param {Object} props
 * @param {string} props.functionId - The ID of the function containing the chart
 * @param {string} props.sourceBlockId - The block that produced the chart
 * @param {string} props.entryKey - The chart manifest entry key
 * @param {string} props.chartType - The type of chart ('bar_chart' or 'line_chart')
 * @param {string} props.companyName - The company name for Firestore path
 *
 * A saved setting is live display configuration on the function head: every
 * surface drawing that chart follows the head, so nothing is handed back here.
 */
function ChartSettingsButton({
  functionId,
  sourceBlockId,
  entryKey,
  chartSpec,
  chartType,
  companyName,
  sx = {}
}) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenSettings = (e) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleCloseSettings = () => setDialogOpen(false);

  return (
    <>
      <Tooltip title="Chart Settings">
        <IconButton
          onClick={handleOpenSettings}
          size="small"
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            padding: '8px',
            transition: 'all 0.2s ease',
            '&:hover': {
              color: '#4E85EB',
              border: '1px solid #4E85EB',
              backgroundColor: 'rgba(78, 133, 235, 0.1)',
            },
            ...sx
          }}
        >
          <SettingsIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <ChartSettings
        open={dialogOpen}
        onClose={handleCloseSettings}
        functionId={functionId}
        sourceBlockId={sourceBlockId}
        entryKey={entryKey}
        chartSpec={chartSpec}
        chartType={chartType}
        companyName={companyName}
      />
    </>
  );
}

export default ChartSettingsButton;
